<template>
  <div>
    <a-modal
      v-model="visible"
      title="签字"
      @ok="handleOk"
      width="460px"
      :keyboard="false"
      :maskClosable="false"
      okText="签字"
      centered
      :getContainer="getContainer"
    >
      <div style="display: flex; justify-content: center; flex-wrap: wrap">
        <div class="item">
          基本信息
          <span @click="show(1)"><a-icon type="eye" /> 查看</span>
        </div>
        <div class="item">
          个人承诺书
          <span @click="show(2)"><a-icon type="eye" /> 查看</span>
        </div>
        <div class="item">
          三级教育卡
          <span @click="show(3)"><a-icon type="eye" /> 查看</span>
        </div>
        <div class="item">
          劳动合同
          <span @click="show(4)"><a-icon type="eye" /> 查看</span>
        </div>
        <!-- <div class="item">
            试卷
            <a-checkbox value="5"></a-checkbox>
          </div> -->
      </div>
      <div class="msg">
        请仔细浏览内容，确认无误后，点击下方“签字”去签字及进行指纹识别。
      </div>
    </a-modal>
    <FileUpdate ref="fileUpdate"></FileUpdate>
  </div>
</template>

<script>
import FileUpdate from "../../files/components/fileupdate";
export default {
  data() {
    return {
      visible: false,
      data: null,
    };
  },
  components: { FileUpdate },
  methods: {
    init(data) {
      this.visible = true;
      this.data = data;
    },
    show(id) {
      this.$refs.fileUpdate.init(id, 'show');
    },
    handleOk() {
      this.$emit("ok", this.data);
      this.visible = false;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.item {
  width: 100%;
  height: 56px;
  background: #ffffff;
  box-shadow: 0px 4px 10px #e6e8f0;
  border-radius: 10px;
  margin: 15px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.item span {
  color: #0073ff;
  cursor: pointer;
}
.msg {
  font-size: 14px;
  font-weight: 400;
  color: #ea1313;
}
</style>